function state() {
  return {
    AgoraToken: "",
    AgoraChannel: "",
    AgoraUid: "",

    classRoomKey: "",
    classTime: "",
    liveChats: [],
    onlineUsers: [],
    HiTutorToken: "",

    classRoomId: "",
    room: null,
    connected: false,
    teacher: true,

    MaterialMediaObject: [],
    MaterialVedioObject: [],
    MaterialObject: [],
    MaterialObjectFrom3000: [],
    ClassroomMaterial: null,

    TeacherName: "",
    UserId: "",
    UserName: "",
    UserType: "",
    LiveChatChannel: "",

    fabricsData: [],
    dynamicCounterMediaFileUrl: false,
    dataGetMaterialByFileUrl: [],

    currentUserCasalomaRegistered: false,
    currentUserCasalomaAccessToken: "",
    currentResponseIMCasaloma: {},
    casalomaRoomName: "",
    checkCasalomaRoomNameAvailability: false,

    user: {},
    jwtToken: "",
    isLoggedIn: false,
    currentlyViewingClass: null,

    IMCasalomaClassAvailability: null,
    IMCasalomaUserAvailability: null,
    IMCasalomaUserLogin: null,
    IMCasalomaUserRegister: null,
    IMCasalomaUserClass: null,

    IMCasalomaFetchChats: null,

    hituteIdentifier: null,

    BeginTimeStamp: null,
    EndTimeStamp: null,

    checkInState: null,
    checkOutState: null,

    LessonRecordUrlStore: "",
    TBUrlStore: "",
    LessonRecordQuery: null,

    errorLogs: [],

    // 畫板-全屏狀態
    teacher_full_status: false,
    // 畫板-操作權限
    teacher_permissions: false,

    // agora-學生麥克風狀態
    teacher_studentMikeStatus: true,
    // agora-學生視訊狀態
    teacher_studentCameraStatus: true,

    teacher_start_class: false,

    // 畫板-全屏狀態
    student_full_status: false,
    // 畫板-操作權限
    student_permissions: false,
    student_drawing_permissions: false,

    // agora-老師麥克風狀態
    student_teacherMikeStatus: true,
    // agora-老師視訊狀態
    student_teacherCameraStatus: true,

    // 畫板-全屏狀態
    employee_full_status: false,
    // 畫板-學生操作權限
    employee_permissions: true,
    // 視訊-學生和員工視訊切換狀態 true學生 false員工
    employee_camera_status: true,

    // agora-老師麥克風狀態
    employee_teacherMikeStatus: true,
    // agora-老師視訊狀態
    employee_teacherCameraStatus: true,
    // agora-學生麥克風狀態
    employee_studentMikeStatus: true,
    // agora-學生視訊狀態
    employee_studentCameraStatus: true,

    // 畫板-全屏狀態
    observation_full_status: false,
    // 畫板-學生操作權限
    observation_permissions: true,

    // agora-老師麥克風狀態
    observation_teacherMikeStatus: true,
    // agora-老師視訊狀態
    observation_teacherCameraStatus: true,
    // agora-學生麥克風狀態
    observation_studentMikeStatus: true,
    // agora-學生視訊狀態
    observation_studentCameraStatus: true,
  };
}

export default state;
